import { useInView } from 'hooks';
import { useEffect, useRef } from 'react';
import { ImageVideo } from 'shared/interfaces';

type LazyImageVideoProps = {
  imageVideo: ImageVideo;
  controls?: boolean;
  releaseOutView?: boolean;
  className?: string;
};

export function LazyLoadVideo({ imageVideo, controls, releaseOutView, className }: LazyImageVideoProps) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const hasLoadedSrc = useRef(false);

  const { ref, isInView } = useInView<HTMLDivElement>({
    threshold: 0.1, // Nên để thấp hơn để video bắt đầu load/play trước khi hiện ra hẳn
  });

  useEffect(() => {
    const el = videoRef.current;
    if (!el) return;

    if (isInView) {
      if (!hasLoadedSrc.current || el.src !== imageVideo.src) {
        el.src = imageVideo.src;
        hasLoadedSrc.current = true;
        el.load();
      }
      el.play().catch(() => {});
    } else {
      el.pause();
      if (releaseOutView && hasLoadedSrc.current) {
        el.removeAttribute('src');
        el.load();
        hasLoadedSrc.current = false;
      }
    }
  }, [isInView, imageVideo.src, releaseOutView]);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden bg-gray-100 ${className}`}
      style={{ aspectRatio: '16/9' }} // Ép khung hình để không bị "nhảy" khi mất src
    >
      <video
        ref={videoRef}
        className='w-full h-full object-cover'
        preload='metadata'
        muted
        loop
        playsInline
        controls={controls && isInView}
      />
    </div>
  );
}
